import type { NavigateFunction } from 'react-router-dom';

import { isDevGlobalAuthEnabled } from '../../shared/config/workspaceHost';
import type { WorkspaceSelection } from './types/workspace';

/**
 * Sends the browser to the selected workspace.
 *
 * In production this is a cross-origin navigation onto the workspace hostname, which is the whole
 * point of the handoff code. In local development there is no workspace hostname, so the code is
 * redeemed on the current origin and the workspace is named explicitly instead.
 */
export const followWorkspaceSelection = (
  selection: WorkspaceSelection,
  navigate: NavigateFunction,
): void => {
  if (isDevGlobalAuthEnabled() && selection.handoffCode) {
    const query = new URLSearchParams({
      code: selection.handoffCode,
      tenantId: selection.tenantId,
    });
    navigate(`/login/handoff?${query.toString()}`, { replace: true });
    return;
  }

  window.location.assign(selection.redirectUrl);
};
